import {defineAsyncComponent, markRaw} from "vue";
import {CheckoutProps} from "../../Components/Checkout.vue";
import LoadingState from "../../Widgets/ModalWidget/Views/components/LoadingState.vue";
import ROUTE_NAMES from "../../Widgets/ModalWidget/Routes/constants";
import {WidgetLocationRaw} from "./contracts";
export class CheckoutRoute implements WidgetLocationRaw {
    public name = ROUTE_NAMES.CHECKOUT;
    public readonly layout: false = false;
    public readonly switchLanguage = false;
    public readonly title: false = false;
    public component = markRaw(defineAsyncComponent({
        loader: () => import( '../../Components/Checkout.vue'),
        loadingComponent : LoadingState
    }));
    public props: CheckoutProps;
    constructor(props: CheckoutProps) {
        this.props = props;
    }
}
